export const DROPDOWN_CONFIG = {
	minWidth: 180,
}